module.exports = __webpack_public_path__ + "img/dispose.fcc712e4.svg";